module.exports = __webpack_public_path__ + "static/img/preview-04.9c9e743a.webp";